import React from "react";
import { Route } from "react-router-dom";
//
import { URL } from "../url";
// component
import LayoutRoot from "../layout/layout_root";
import PrivateRoute from "../component/private_route";
//client
import ClientScreen from "screen/02_Client/client";
//
import DevScreen from "screen/100_Dev/dev";
import DraftBailiffScreen from "screen/03_Draft/01_Bailiff/draft_bailiff";
import KycDetail from "screen/02_Client/02_KYC/kyc_detail";
import HistoryScreen from "screen/03_History/history";
// import DraftDialogScreen from "screen/03_Draft/02_Dialog/dialog_screen";
// import SegmentScreen from "screen/03_Draft/03_Segment/segment_screen";

//concept

const PERMISSION_SCREEN = "fdb";

export const routerPrivate = () => {
  // -------------------------- STATE --------------------------

  // -------------------------- FUNCTION --------------------------

  // -------------------------- RENDER --------------------------
  const renderGroupClient = () => {
    return (
      <>
        <Route
          path={URL.client}
          element={
            <PrivateRoute
              require={[PERMISSION_SCREEN]}
              element={<DraftBailiffScreen />}
            />
          }
        />
        <Route
          path={URL.kyc}
          element={
            <PrivateRoute
              require={[PERMISSION_SCREEN]}
              element={<KycDetail />}
            />
          }
        />
        <Route
          path={URL.history}
          element={
            <PrivateRoute
              require={[PERMISSION_SCREEN]}
              element={<HistoryScreen />}
            />
          }
        />
      </>
    );
  };
  // -------------------------- MAIN --------------------------
  return (
    <Route exact path={URL.home} element={<LayoutRoot />}>
      <Route
        index
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<ClientScreen />}
          />
        }
      />

      {/* // client */}
      {renderGroupClient()}

      {/* // dialog */}
      {/* <Route
        path={URL.dialog}
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<DraftDialogScreen />}
          />
        }
      /> */}

      {/* // dialog */}
      {/* <Route
        path={URL.segment}
        element={
          <PrivateRoute
            require={[PERMISSION_SCREEN]}
            element={<SegmentScreen />}
          />
        }
      /> */}

      <Route
        path={URL.dev}
        element={<PrivateRoute require={[]} element={<DevScreen />} />}
      />
    </Route>
  );
};
